import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "@/lib/site-data";

export const Testimonials = () => {
  return (
    <section id="avis" data-testid="testimonials-section" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="mb-14 max-w-3xl">
          <div className="eyebrow mb-4">Ils nous ont fait confiance</div>
          <h2 className="font-heading text-5xl md:text-7xl uppercase tracking-tight text-white leading-[0.9]">
            <span className="silver-text">Avis</span> de nos <span className="text-bgtp-orange">clients</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <div key={i} data-testid={`testimonial-${i}`} className="industrial-card flex flex-col">
              <Quote className="w-8 h-8 text-bgtp-orange mb-4" strokeWidth={2} />
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, k) => (
                  <Star key={k} className="w-4 h-4 fill-bgtp-orange text-bgtp-orange" />
                ))}
              </div>
              <p className="text-white/85 text-[15px] leading-relaxed mb-6 flex-1">
                "{t.text}"
              </p>
              <div className="pt-4 border-t border-bgtp-line">
                <div className="font-heading text-xl uppercase tracking-wider text-white">{t.name}</div>
                <div className="text-xs tracking-[0.2em] uppercase text-bgtp-steel">{t.city}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
